export const getValue = <TData extends string | number>(item: {
  value: TData
  label: string
}) => item.value
